import { baseApi } from './baseApi';

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReport: builder.query({
      query: ({ reportType, fromDate, toDate }) => ({
        url: `/reports/${reportType}`,
        params: { fromDate, toDate },
      }),
      providesTags: (result, error, { reportType }) => [{ type: 'Report', id: reportType }],
    }),
  }),
});

export const { useGetReportQuery } = reportsApi;
